import React, { useState, useRef, useEffect, useLayoutEffect } from 'react'
import { Avatar, Box, Grid, IconButton, LinearProgress, ListItemIcon, ListItemText, MenuItem, MenuList, TextField, Theme, Tooltip, Typography } from '@mui/material'
import "./styleChat.css";
import { makeStyles, useTheme } from "@mui/styles";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { BtnIcon, BtnSend } from 'components/Common/Button';
import InputEmoji from 'react-input-emoji'
import { ImAttachment } from "react-icons/im";
import moment from 'moment';
import { AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import { boolean } from 'yup/lib/locale';
import parse from 'html-react-parser';
import axios from 'axios';
import { SiMicrosoftexcel } from 'react-icons/si';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { BsFillFileEarmarkWordFill } from "react-icons/bs";
import PhotoIcon from '@mui/icons-material/Photo';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { AuthToken, currentLanguage } from 'service/CommonFunction/AxiosConfig';
import InputMessage from './InputMessage';

const useStyles = makeStyles((theme: Theme) => ({
    WordColor: {
        color: "#fff !important",
        backgroundColor: "#2372ba !important",
        borderColor: "#2372ba !important",
        margin: theme.spacing(1),
        "&:hover": {
            backgroundColor: "rgb(56, 151, 234) !important",
        },
    },
    ExcelColor: {
        color: "#fff !important",
        backgroundColor: "#14a73c !important",
        borderColor: "#14a73c !important",
        margin: theme.spacing(1),
        "&:hover": {
            backgroundColor: "rgb(66, 201, 127) !important",
        },
    },
    PDFColor: {
        color: "#fff !important",
        backgroundColor: "#ff0000 !important",
        borderColor: "#ff0000 !important",
        margin: theme.spacing(1),
        "&:hover": {
            backgroundColor: "rgb(255, 79, 79) !important",
        },
    },
    PowerPointColor: {
        color: "#fff !important",
        backgroundColor: "#f26522 !important",
        borderColor: "#f26522 !important",
        margin: theme.spacing(1),
        "&:hover": {
            backgroundColor: "rgb(255, 79, 79) !important",
        },
    },

    FileItem: {
        margin: "0 !important",
        // padding: "20px 16px 20px 22px !important",
        // borderBottom: "1px solid #ebeef1 !important",
        animationDuration: ".6s !important",
    },
    ColumnThumbnail: {
        paddingLeft: "10px",
    },
    ColumnTitle: {
        flex: "1 !important",
        paddingLeft: "16px !important",
        paddingRight: "16px !important",
        color: "#74809d !important",
        overflow: "hidden !important",
        backgroundColor: "#fffff !important",
        cursor: "pointer !important",
    },
    ColumnAction: {
        margin: "0 16px",
    },
    Title: {
        fontWeight: 600,
    },
    DangerColor: {
        color: "#fff !important",
        backgroundColor: "#ed3847 !important",
        borderColor: "#ed3847 !important",
        margin: theme.spacing(1),
        "&:hover": {
            backgroundColor: "rgb(220, 53, 69) !important",
        },
    },
    WarningColor: {
        color: "#fff !important",
        backgroundColor: "#ffce3d !important",
        borderColor: "#ffce3d !important",
        margin: theme.spacing(1),
        "&:hover": {
            backgroundColor: "rgb(252, 189, 0) !important",
        },
    },

    IConColor: {
        fill: "currentColor",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fontSize: "1.5rem",
        transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
}));

const FeedChat = (props) => {
    const classes = useStyles();
    const { sendMessage, sendFile, sendDisplayImage, Messages, usersFrom, users, chatID, sPathImage } = props;
    const messageRef = useRef() as any;
    const isBottomScroll = useRef(true) as any;
    const [text, setText] = useState('');
    const [nProgressFile, setProgressFile] = useState<number>(0);
    const [arrFecthMessage, setFecthMessage] = useState<any>([]);

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const schema = yup.object().shape({
        sMessage: yupFormSchemas.string("ข้อความ", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        if (messageRef && messageRef.current) {
            //Step 1 Check User Is Chat
            if (usersFrom == users) {
                setFecthMessage([...Messages]);
                setTimeout(() => {
                    if (messageRef.current != null) {
                        messageRef.current.scrollTo({ left: 0, top: messageRef.current.scrollHeight, behavior: 'smooth' });
                    }
                }, 300);
            }
            else if (usersFrom != users) {
                let isChatID = Messages.filter(f => f.nChatID == chatID);
                if (isChatID.length > 0) {
                    setFecthMessage([...Messages]);
                    if (isBottomScroll.current) {
                        setTimeout(() => {
                            if (messageRef.current != null) {
                                messageRef.current.scrollTo({ left: 0, top: messageRef.current.scrollHeight, behavior: 'smooth' });
                            }
                        }, 300);
                    }
                }
            }
        }

    }, [Messages]);

    const handleOnEnter = (text) => {
        if (text) {
            if (text.length <= 500) {
                sendMessage(text);
                setText("");
            }
            else {
                setIsOpenSnackbar(true);
                setsMessageSnackbar("ข้อความต้องมีความยาวไม่เกิน 500 ตัวอักษร")
                setsSeveritySnackbar("warning")
            }
        }
    }

    const handleUploadFile = (e) => {
        let ExtensionFile = ["jpg", "jpeg", "png", "gif", "doc", "docx", "xls", "xlsx", "pdf"];
        var mimes = [
            {
                mime: "image/jpeg",
                pattern: [0xff, 0xd8, 0xff],
                mask: [0xff, 0xff, 0xff],
            },
            {
                mime: "image/png",
                pattern: [0x89, 0x50, 0x4e, 0x47],
                mask: [0xff, 0xff, 0xff, 0xff],
            },
            {
                mime: "image/gif",
                pattern: [0x47, 0x49, 0x46, 0x38],
                mask: [0xff, 0xff, 0xff, 0xff],
            },
            {
                mime: "application/pdf",
                pattern: [0x25, 0x50, 0x44, 0x46],
                mask: [0xff, 0xff, 0xff, 0xff],
            },
            {
                mime: "video/avi",
                pattern: [0x52, 0x49, 0x46, 0x46], //+ 41 56 49 20
                mask: [0xff, 0xff, 0xff, 0xff],
            },
            {
                mime: "text/plain UTF-16BE BOM",
                pattern: [0xfe, 0xff, 0x00, 0x00],
                mask: [0xff, 0xff, 0x00, 0x00],
            },
            {
                mime: "text/plain UTF-16LE BOM",
                pattern: [0xff, 0xfe, 0x00, 0x00],
                mask: [0xff, 0xff, 0x00, 0x00],
            },
            {
                mime: "text/plain UTF-8 BOM",
                pattern: [0xef, 0xbb, 0xbf, 0x00],
                mask: [0xff, 0xff, 0xff, 0x00],
            },
        ];
        let sExtensionFile = ExtensionFile.join(' ,');
        let isPassFile: boolean = true;
        let arrFile = [];
        let arrFileError = [];
        for (let i = 0; i < e.target.files.length; i++) {
            let objFile = e.target.files[i];
            objFile["sKeyProgress"] = "UPD_" + (new Date().valueOf() + i);
            arrFile.push(objFile);
        }
        arrFile.forEach((item) => {
            let sFileName = item.name;
            let arrFileName = sFileName.split(".");
            let sExtention = (arrFileName[arrFileName.length - 1] + "").toLocaleLowerCase().trim();
            //Step 1 Check Extension File
            if (ExtensionFile.indexOf(sExtention) != -1) {
                // if (Extension.Image.indexOf(sExtention) > 0) {
                //     if (window.FileReader && window.Blob) {
                //         // All the File APIs are supported.
                //     } else {
                //         // File and Blob are not supported
                //         arrFileError.push({ sFileName: sFileName, sMessage: "File and Blob are not supported" });
                //     }
                // }
                //Step 2 Check Size File
                const nMaxSize = 10;
                const fileSize = item.size / 1024 / 1024; // in MiB
                if (fileSize > nMaxSize) {
                    arrFileError.push({ sFileName: sFileName, sMessage: "ขนาดไฟล์สูงสุดไม่เกิน " + nMaxSize + " MiB" });
                }
            }
            else {
                arrFileError.push({ sFileName: sFileName, sMessage: "อนุญาตเฉพาะประเภท: " + sExtensionFile + " เท่านั้น." });
            }
        });

        //Clear File After Error
        if (arrFileError.length > 0) {
            let sMessage = "";
            arrFileError.forEach((Item) => {
                sMessage += "ไฟล์ " + Item.sFileName + " : " + Item.sMessage + "<br>";
            })
            setIsOpenSnackbar(true);
            setsMessageSnackbar(parse(sMessage))
            setsSeveritySnackbar("warning")
            clearUploadFile();
        }
        else {
            UploadFileToChat(arrFile);
        }
    }

    const UploadFileToChat = async (arrFile) => {
        const auth_token = AuthToken.get();
        // let url = process.env.REACT_APP_API_URL;
        // let sPathApi = url + "api/Chat/UploadFileToChat";

        const baseUrl = process.env.REACT_APP_API_URL
        const sPathApi = `${baseUrl}api/Chat/UploadFileToChat`
        const url = new URL(sPathApi, window.location.href);

        const sNewPath = url.origin + url.pathname + url.search;

        for (let item of arrFile) {
            const result = await sendFile(item);
        }

        setTimeout(async () => {
            for (let item of arrFile) {
                let divProgress = document.getElementById(item.sKeyProgress) as HTMLDivElement;
                let txtMessageID = document.getElementById("txtMessageID_" + item.sKeyProgress) as HTMLInputElement;

                if (divProgress) {
                    divProgress.style.display = "block";
                }
                let nMessageID = "";
                if (txtMessageID) {
                    nMessageID = txtMessageID.value;
                }

                const formPayload = new FormData();
                formPayload.append("file", item);
                formPayload.append("nChatID", chatID);
                formPayload.append("nMessageID", nMessageID);
                // sendFile
                const result = await axios({
                    url: sNewPath,
                    // url: sPathApi,
                    method: "post",
                    data: formPayload,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${auth_token}`,
                    },
                    onUploadProgress: (progressEvent) => {
                        const { loaded, total } = progressEvent;
                        const nProgress = Math.floor((loaded / total) * 100);
                        if (nProgress == 100) {
                            setProgressFile(0);
                        }
                        else {
                            setProgressFile(nProgress);
                        }
                    },
                })
                    .then(async (response) => {
                        if (divProgress) {
                            divProgress.style.display = "none";
                        }
                        let ExtensionFile = ["jpg", "jpeg", "png", "gif"];
                        let sFileName = item.name;
                        let arrFileName = sFileName.split(".");
                        let sExtention = (arrFileName[arrFileName.length - 1] + "").toLocaleLowerCase().trim();
                        if (ExtensionFile.indexOf(sExtention) != -1) {
                            let objDataImage = {
                                nMessageID: response.data.nID,
                                sKeyProgress: item.sKeyProgress
                            }
                            const result = await sendDisplayImage(objDataImage);
                        }
                        clearUploadFile();
                    })
                    .catch(function (error) {

                    });
            }
        }, 1000);
    }

    const clearUploadFile = () => {
        let ctrl = document.getElementById('fileUploadChat') as HTMLInputElement;
        if (ctrl) {
            ctrl.value = '';
        }
    };

    const contentMessage = (item, inx) => {

        if (item.isFile) {
            let arrFileName = item.sFileName.split(".");
            let sExtention = (arrFileName[arrFileName.length - 1] + "").toLocaleLowerCase();
            switch (sExtention) {
                case "xls":
                case "xlsx":
                    return (
                        <MenuList style={{ padding: "0px" }}>
                            <MenuItem style={{ padding: "5px" }} onClick={() => { onClickFile(item) }} >
                                <ListItemIcon>
                                    <IconButton className={classes.ExcelColor} size="small">
                                        <SiMicrosoftexcel className={classes.IConColor} />
                                    </IconButton>
                                </ListItemIcon>
                                <ListItemText> <p className='messageFile'>{item.sFileName}</p></ListItemText>
                            </MenuItem>
                            <MenuItem id={item.sKeyProgress ? item.sKeyProgress : "div_" + inx} style={{ display: 'none' }}>
                                <Box display="flex" alignItems="center">
                                    <Box width="100%" mr={1}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={nProgressFile || 0}
                                            color={'warning'}
                                        />
                                    </Box>
                                </Box>
                            </MenuItem>
                        </MenuList>
                    )
                case "doc":
                case "docx":
                    return (
                        <MenuList style={{ padding: "0px" }}>
                            <MenuItem style={{ padding: "5px" }} onClick={() => { onClickFile(item) }} >
                                <ListItemIcon>
                                    <IconButton className={classes.WordColor} size="small">
                                        <BsFillFileEarmarkWordFill className={classes.IConColor} />
                                    </IconButton>
                                </ListItemIcon>
                                <ListItemText> <p className='messageFile'>{item.sFileName}</p></ListItemText>
                            </MenuItem>
                            <MenuItem id={item.sKeyProgress ? item.sKeyProgress : "div_" + inx} style={{ display: 'none' }}>
                                <Box display="flex" alignItems="center">
                                    <Box width="100%" mr={1}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={nProgressFile || 0}
                                            color={'warning'}
                                        />
                                    </Box>
                                </Box>
                            </MenuItem>
                        </MenuList>
                    )
                case "pdf":
                    return (
                        <MenuList style={{ padding: "0px" }}>
                            <MenuItem style={{ padding: "5px" }} onClick={() => { onClickFile(item) }} >
                                <ListItemIcon>
                                    <IconButton className={classes.PDFColor} size="small">
                                        <PictureAsPdfIcon className={classes.IConColor} />
                                    </IconButton>
                                </ListItemIcon>
                                <ListItemText> <p className='messageFile'>{item.sFileName}</p></ListItemText>
                            </MenuItem>

                        </MenuList>
                    )
                default:
                    let src = process.env.REACT_APP_API_URL + item.sPath + "/" + item.sSystemFileName;
                    return (
                        <MenuList style={{ padding: "0px" }}>
                            <MenuItem style={{ padding: "5px" }} onClick={() => { onClickFile(item) }} >
                                <ListItemText style={{ lineHeight: "1" }}>
                                    <div id={item.sKeyProgress ? "div_" + item.sKeyProgress : "div_" + inx} style={{ lineHeight: "1", padding: "2px" }}>
                                        {
                                            item.sKeyProgress ?
                                                <PhotoIcon style={{ fontSize: "50px" }}></PhotoIcon>
                                                : <img id={"img_" + item.sKeyProgress ? item.sKeyProgress : inx} src={src} alt="" style={{ height: "100%", width: "100%", maxHeight: "7vw" }} />
                                        }
                                    </div>
                                </ListItemText>
                            </MenuItem>
                            <MenuItem id={item.sKeyProgress ? item.sKeyProgress : "div_" + inx} style={{ display: 'none' }}>
                                <Box display="flex" alignItems="center">
                                    <Box width="100%" mr={1}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={nProgressFile || 0}
                                            color={'warning'}
                                        />
                                    </Box>
                                </Box>
                            </MenuItem>
                        </MenuList>
                    )
                // return (
                //     <div id={item.sKeyProgress ? "div_" + item.sKeyProgress : "div_" + inx}>
                //         {
                //             item.sKeyProgress ?
                //                     <PhotoIcon style={{ fontSize: "50px" }}></PhotoIcon>
                //                 : <img id={"img_" + item.sKeyProgress ? item.sKeyProgress : inx} src={src} alt="" style={{ height: "100%", width: "100%", maxHeight: "7vw" }} />
                //         }
                //         <div id={item.sKeyProgress ? item.sKeyProgress : "div_" + inx} style={{ display: 'none' }}>
                //             <Box display="flex" alignItems="center">
                //                 <Box width="100%" mr={1}>
                //                     <LinearProgress
                //                         variant="determinate"
                //                         value={nProgressFile || 0}
                //                         color={'warning'}
                //                     />
                //                 </Box>
                //             </Box>
                //         </div>
                //     </div>
                // );
            }

        }
        else {
            return (<p className='message'>{item.sMessage}</p>);
        }
    };

    const onClickFile = (item) => {
        let sPath = process.env.REACT_APP_API_URL + item.sPath + "/" + item.sSystemFileName;
        window.open(sPath)
    };

    const onFecthChatMessage = async () => {
        let nMessageID = 0;
        if (arrFecthMessage.length > 0) {
            nMessageID = (Math.min.apply(Math, arrFecthMessage.map(function (o) { return o.nMessageID; })));
        }
        else {
            nMessageID = Messages.length > 0 ? (Math.min.apply(Math, Messages.map(function (o) { return o.nMessageID; }))) : 1;
        }
        if (chatID) {
            await AxiosGet(`Chat/FecthChatMessage`, { nChatID: chatID, nMessageID: nMessageID }, (res) => {
                ResultAPI(res, null, async () => {
                    if (res.lstChatMessage.length > 0) {
                        setFecthMessage(messages => [...res.lstChatMessage, ...messages]);
                        if (messageRef.current) {
                            const { scrollHeight, clientHeight } = messageRef.current;
                            let calTopPercentage = clientHeight - (clientHeight * 0.2);
                            messageRef.current.scrollTo({ left: 0, top: calTopPercentage, behavior: 'smooth' });
                        }

                    }
                })
            })
        }

    };

    return (
        <div style={{ padding: '16px', minHeight: '500px', position: 'relative', border: '1px solid #bdbdbd', borderRadius: '10px' }}>
            {
                chatID == 0 ? null
                    : <div className='chat'>
                        <div ref={messageRef} id={"message-container"} className='message-container'
                            onScroll={(e) => {
                                if (messageRef.current) {
                                    let scrollHeight = messageRef.current.scrollHeight - 3;
                                    if (messageRef.current.scrollTop == 0) {
                                        onFecthChatMessage();
                                        isBottomScroll.current = false;
                                    }
                                    else if (messageRef.current.scrollTop + messageRef.current.offsetHeight >= scrollHeight) {
                                        isBottomScroll.current = true;
                                    }
                                    else {
                                        isBottomScroll.current = false;
                                    }
                                }
                            }}
                        >
                            {arrFecthMessage.map((m, index) => {
                                let isFromChat: boolean = (users == m.nFromUserID);
                                let sClassMessage = isFromChat ? "bg-from-user" : "bg-to-user";
                                if (m.isFile) {
                                    sClassMessage = isFromChat ? "bgfile-from-user" : "bgfile-to-user";
                                }
                                let divPanelMessageID = "";
                                if (index == 0) {
                                    divPanelMessageID = "divPanelMessage_" + m.sKeyProgress;
                                }

                                return (
                                    <Grid id={divPanelMessageID} container direction={isFromChat ? "row-reverse" : "row"} justifyContent="flex-start" alignItems="center" style={{ marginBottom: '8px' }}>
                                        <Grid item style={{ display: (isFromChat ? "none" : "block") }}>
                                            <input hidden id={"txtMessageID_" + m.sKeyProgress} value={m.nMessageID || ""}></input>
                                            <Avatar
                                                alt="Remy Sharp"
                                                src={sPathImage}
                                                sx={{ width: 30, height: 30, margin: '0 6px 0px 4px' }}
                                            />
                                        </Grid>
                                        <Grid item className={sClassMessage}>
                                            {
                                                contentMessage(m, index)
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            <p className={isFromChat ? "date-send-reverse" : "date-send"} style={{ textAlign: isFromChat ? "right" : "left" }}>{moment(m.dSend).add(543, 'year').format("DD/MM/YYYY HH:mm น.")}</p>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </div>
                        <div style={{ position: 'absolute', bottom: '8px', right: '2%', width: '96%', border: '1px solid #bdbdbd', borderRadius: '10px', padding: '6px', backgroundColor: '#ffffff' }}>
                            <input type="file" id={"fileUploadChat"} multiple hidden onChange={handleUploadFile} />
                            <FormProvider {...form}>
                                <Grid container direction="row" spacing={1} justifyContent="space-around" alignItems="center" >
                                    <Grid item >
                                        <BtnIcon
                                            txtTooltip={
                                                currentLanguage() == "th" ?
                                                    "อนุญาตเฉพาะประเภท: .pdf, .jpg, .jpeg, .png, \n.gif, .doc, .docx, .xls, .xlsx, .rar, .zip เท่านั้น.\n ขนาดไฟล์สูงสุดไม่เกิน 10 MB."
                                                    :
                                                    "Allowed file types: .pdf, .jpg, .jpeg, .png, \n.gif, .doc, .docx, .xls, .xlsx, .rar, .zip. File size limits up to  10 MB."
                                            }
                                            startIcon={<ImAttachment style={{ color: '#000000' }} />}
                                            HoverBackgroungColor="#dcdcdc"
                                            BackgroungColor="#c4c4c4"
                                            BorderColor="#c4c4c4"
                                            onClick={() => {
                                                let ctrl = document.getElementById('fileUploadChat') as HTMLInputElement;
                                                if (ctrl) {
                                                    ctrl.click();
                                                }
                                            }}
                                            isDisabled={chatID == 0}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={9}>
                                        {/* <InputEmoji
                                            value={text}
                                            onChange={setText}
                                            cleanOnEnter
                                            onEnter={(e) => {
                                                handleOnEnter(e);
                                            }}
                                            placeholder={ currentLanguage() == "th" ? "กรอกข้อความ" : "Enter input"}
                                            maxLength={500}
                                            onResize={(e) => {

                                            }}
                                            height={40}

                                        /> */}
                                        
                                        <InputMessage 
                                            value={text} 
                                            setValue={setText} 
                                            handleOnEnter={handleOnEnter}
                                        />
                                    </Grid>
                                    <Grid item >
                                        <BtnSend txt={currentLanguage() == "th" ? "ส่ง" : "Send"} onClick={(e) => {
                                            if (text) {
                                                if(text.length <= 500)
                                                {
                                                    sendMessage(text);
                                                    setText("");
                                                }
                                                else{
                                                    setIsOpenSnackbar(true);
                                                    setsMessageSnackbar("ข้อความต้องมีความยาวไม่เกิน 500 ตัวอักษร")
                                                    setsSeveritySnackbar("warning")
                                                }
                                            }
                                        }} />
                                    </Grid>
                                </Grid>
                            </FormProvider>
                        </div>
                    </div>
            }

            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </div >
    )
}

export default FeedChat